var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import HomeLineSvg from './home-line.icon.svg';
export const HomeLineIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: HomeLineSvg }));
_react_refresh_temp_1 = HomeLineIcon;
$RefreshReg$(_react_refresh_temp_1, "HomeLineIcon");
